export default "__VITE_ASSET__CZt8Uvtb__"